/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷数量6
 * @export
 * @interface Col6
 */
export interface Col6 {
}

/**
 * Check if a given object implements the Col6 interface.
 */
export function instanceOfCol6(value: object): value is Col6 {
    return true;
}

export function Col6FromJSON(json: any): Col6 {
    return Col6FromJSONTyped(json, false);
}

export function Col6FromJSONTyped(json: any, ignoreDiscriminator: boolean): Col6 {
    return json;
}

export function Col6ToJSON(json: any): Col6 {
    return Col6ToJSONTyped(json, false);
}

export function Col6ToJSONTyped(value?: Col6 | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

